import { Layout } from '@arco-design/web-react';
import styles from './style.module.less';

const { Footer: ArcoFooter } = Layout;

export default function Footer() {
  return (
    <ArcoFooter className={styles.footer}>
      <span>LetsFly Admin © {new Date().getFullYear()}</span>
    </ArcoFooter>
  );
}
